import { Box, Card, CardHeader, CardContent, TextField, useMediaQuery, useTheme } from '@mui/material';
import { UnfoldMore, KeyboardArrowUp, KeyboardArrowDown } from '@mui/icons-material';

import './OkkoStationsTable.css';
import { OkkoStationsTableProps } from './OkkoStationsTable.types';

export function OkkoStationsTable({
  searchQuery,
  selectedStation,
  sortField,
  sortDirection,
  sortedStations,
  onSearchChange,
  onSort,
  onStationSelect
}: OkkoStationsTableProps) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const getSortIcon = (column: string) => {
    if (sortField !== column) return <UnfoldMore />;
    return sortDirection === 'asc' ? <KeyboardArrowUp /> : <KeyboardArrowDown />;
  };

  return (
    <Box className="okko-stations-table-container">
      <Card className="okko-stations-card">
        <CardHeader title="АЗК ОККО" className="okko-stations-card-header" />
        <CardContent className="okko-stations-card-content">
          <Box className="okko-stations-search-container">
            <TextField
              placeholder="Пошук"
              value={searchQuery}
              onChange={e => onSearchChange(e.target.value)}
              size="small"
              fullWidth
              className="okko-stations-search-input"
            />
          </Box>

          {!isMobile && (
            <div className="okko-stations-desktop-header">
              <div
                className="okko-stations-desktop-header-cell okko-h-col-10 sortable"
                onClick={() => onSort('station_number')}
              >
                №<div className="okko-sort-icon">{getSortIcon('station_number')}</div>
              </div>
              <div className="okko-stations-desktop-header-cell okko-h-col-45 sortable" onClick={() => onSort('address')}>
                Адреса
                <div className="okko-sort-icon">{getSortIcon('address')}</div>
              </div>
              <div className="okko-stations-desktop-header-cell okko-h-col-22 sortable" onClick={() => onSort('region')}>
                Регіон
                <div className="okko-sort-icon">{getSortIcon('region')}</div>
              </div>
              <div
                className="okko-stations-desktop-header-cell okko-h-col-23 sortable"
                onClick={() => onSort('province')}
              >
                Область
                <div className="okko-sort-icon">{getSortIcon('province')}</div>
              </div>
            </div>
          )}

          <Box className="okko-stations-table">
            <div className="okko-table-wrapper">
              <div className="okko-stations-results-table">
                {isMobile && (
                  <div className="okko-stations-table-header">
                    <div className="okko-stations-table-header-row">
                      <div
                        className="okko-stations-table-header-cell okko-col-10 sortable"
                        onClick={() => onSort('station_number')}
                      >
                        №<div className="okko-sort-icon">{getSortIcon('station_number')}</div>
                      </div>
                      <div
                        className="okko-stations-table-header-cell okko-col-45 sortable"
                        onClick={() => onSort('address')}
                      >
                        Адреса
                        <div className="okko-sort-icon">{getSortIcon('address')}</div>
                      </div>
                      <div
                        className="okko-stations-table-header-cell okko-col-22 sortable"
                        onClick={() => onSort('region')}
                      >
                        Регіон
                        <div className="okko-sort-icon">{getSortIcon('region')}</div>
                      </div>
                      <div
                        className="okko-stations-table-header-cell okko-col-23 sortable"
                        onClick={() => onSort('province')}
                      >
                        Область
                        <div className="okko-sort-icon">{getSortIcon('province')}</div>
                      </div>
                    </div>
                  </div>
                )}
                {sortedStations.map(station => (
                  <div
                    key={station.unicode}
                    onClick={() => onStationSelect(station)}
                    className={`okko-stations-table-row ${selectedStation?.unicode === station.unicode ? 'selected-okko' : ''}`}
                  >
                    <div className="okko-stations-table-cell okko-col-10">{station.station_number}</div>
                    <div className="okko-stations-table-cell okko-col-45">{station.address}</div>
                    <div className="okko-stations-table-cell okko-col-22">{station.region}</div>
                    <div className="okko-stations-table-cell okko-col-23">{station.province}</div>
                  </div>
                ))}
              </div>
            </div>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}
